var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c("HeaderLandingNew"),
      _vm._v(" "),
      _c("div", { staticClass: "section-one section-missions" }, [
        _c("div", { staticClass: "so-content" }, [
          _c("h1", [_vm._v("Missions")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        Donate to MusicVerse to support missions MusicVerse is also a 501c3\n        organization that can provide tax deductible receipts for US\n      "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "so-content-action" }, [
            _c(
              "a",
              {
                staticClass: "btn-n primary",
                attrs: { "aria-label": "Learn More MusicVerse", href: _vm.url }
              },
              [_vm._v("\n          Explore Missions\n        ")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-section donat-list" },
        _vm._l(_vm.dataDonations, function(item) {
          return _c("div", { key: item.id, staticClass: "content-section-2" }, [
            _c(
              "div",
              { staticClass: "donat-list-item" },
              [
                _c(
                  "b-carousel",
                  {
                    attrs: {
                      id: "carousel-" + item.id,
                      interval: 4000,
                      fade: "",
                      controls: "",
                      "img-width": "100%",
                      "img-height": "auto"
                    }
                  },
                  _vm._l(item.images, function(image, index) {
                    return _c("b-carousel-slide", {
                      key: index,
                      staticClass: "custom-image-slider",
                      attrs: { "img-src": image }
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dli-info" }, [
                  _c("div", { staticClass: "dli-top" }, [
                    _c("h4", [_vm._v(_vm._s(item.name))]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(item.description))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "dli-bottom" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn-n primary",
                        staticStyle: { width: "100%" },
                        on: {
                          click: function($event) {
                            return _vm.donate(item.id)
                          }
                        }
                      },
                      [_vm._v("Donate to " + _vm._s(item.name))]
                    )
                  ])
                ])
              ],
              1
            )
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("FooterLandingNew")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9ef2a40a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ef2a40a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/DonationPage.vue
// module id = null
// module chunks = 